import React from 'react';

import useMount from 'ggApp/shared/hooks/useMount';

import { pointPropTypes } from '../../hocs';
import RentalPlanSelector from './rentalPlanSelector';
import { RentalPlan } from '../../types';

export interface RentalPlanSelectorWrapProps {
    rentalPlans: Array<RentalPlan>;
    points: Array<typeof pointPropTypes>;
    className: string;
    selectedPlan: RentalPlan;
    rentalPlanIndex: number;
    changeRentalPlan: () => {};
    setRentalPlanIndex: (arg1: number) => {};
    selectedMinDuration: number;
}

const RentalPlanSelectorWrap = ({
    points,
    className,
    selectedPlan,
    rentalPlanIndex,
    changeRentalPlan,
    rentalPlans,
    setRentalPlanIndex,
    selectedMinDuration,
}: RentalPlanSelectorWrapProps): JSX.Element => {
    useMount(() => {
        const selectedRentalPlanIndex = rentalPlans.findIndex(
            (el) => el.minimumMonths === selectedMinDuration,
        );

        const defaultRentalPlanIndex =
            selectedRentalPlanIndex > -1 ? selectedRentalPlanIndex : rentalPlans.length - 1;
        setRentalPlanIndex(defaultRentalPlanIndex);
    });

    return (
        <RentalPlanSelector
            points={points}
            className={className}
            selectedPlan={selectedPlan}
            rentalPlanIndex={rentalPlanIndex}
            setRentalPlanIndex={changeRentalPlan}
        />
    );
};

export default RentalPlanSelectorWrap;
